import { Star, FileText, MessageSquare, ExternalLink, Megaphone } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const PROOF = [
  {
    icon: Star,
    title: "4.5/5 on Trustpilot",
    text: "Read thousands of independent, unfiltered Honeygain reviews — the good months and the slow ones — before you join.",
    href: "https://www.trustpilot.com/review/honeygain.com",
    cta: "Read the reviews",
    testid: "proof-trustpilot",
  },
  {
    icon: FileText,
    title: "Terms on the record",
    text: "The $20 payout threshold, the per-GB rate and JumpTask mode are published on Honeygain's own site — not invented here.",
    href: "https://www.honeygain.com/",
    cta: "Check the official terms",
    testid: "proof-official",
  },
  {
    icon: MessageSquare,
    title: "Ask the community",
    text: "r/Honeygain and r/beermoney discuss real payout receipts, slow months and setup tips — straight from people running it.",
    href: "https://www.reddit.com/r/Honeygain/",
    cta: "Browse the subreddit",
    testid: "proof-community",
  },
];

const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="py-20 sm:py-28 honey-grain">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="text-center">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-amber-700">Proof</p>
        <h2 className="mt-3 font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-zinc-900">
          Don't take our word for it — check for yourself
        </h2>
        <p className="mt-4 text-base text-zinc-600 max-w-2xl mx-auto leading-relaxed">
          We removed the stock-photo testimonial section this site launched with. Recycled quotes and
          generated faces don't belong on a page about trust. Here is what you can verify independently instead.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-5 md:grid-cols-3">
        {PROOF.map(({ icon: Icon, title, text, href, cta, testid }, i) => (
          <Reveal key={title} delay={i * 0.1}>
            <a
              data-testid={testid}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col h-full rounded-3xl border border-zinc-100 bg-white p-7 shadow-sm hover:shadow-xl hover:shadow-amber-900/5 hover:-translate-y-1 hover:border-amber-200 transition-all"
            >
              <div className="grid place-items-center w-11 h-11 rounded-2xl bg-amber-400 text-zinc-900">
                <Icon className="w-5 h-5" />
              </div>
              <h3 className="mt-5 font-display text-lg font-bold text-zinc-900">{title}</h3>
              <p className="mt-2 text-sm text-zinc-600 leading-relaxed flex-1">{text}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 font-display font-bold text-sm text-amber-700">
                {cta}
                <ExternalLink className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" />
              </span>
            </a>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p
          data-testid="proof-member-stories-note"
          className="mt-8 mx-auto max-w-2xl text-center rounded-2xl border border-amber-200 bg-amber-50 px-6 py-4 text-sm text-amber-900 inline-flex items-start gap-2.5 w-full sm:w-auto sm:inline-flex"
        >
          <Megaphone className="w-4 h-4 mt-0.5 shrink-0" />
          Joined through this page and cashing out? Real member stories are being collected and will
          appear here — with permission, names and screenshots included.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Testimonials;
